/**
 * A catalog value as display text.
 *
 * EntityRecord is Record<string, unknown>, so `String(row['code'])` would render a nested object
 * as the literal '[object Object]' — what the operator would see in a delete confirmation, and
 * what sonar's S6551 flags. Anything that is not a primitive has no sensible text form here, so
 * it reads as empty rather than as noise.
 */
export function entityText(value: unknown, fallback = ''): string {
  if (value === null || value === undefined) return fallback;
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
    return String(value);
  }
  return fallback;
}
